var React = require("react");

/**
 * This function takes in a string containing a bounding box (bbox) and returns an array of coordinates in the format required for a map.
 * @param {string} bbox_string - The string representation of the bbox in the format "xmin,ymin,xmax,ymax".
 * @returns {Array} The array of coordinates in the format [[xmin, ymin], [xmax, ymax]].
 */
export const createCoordsBoundsFromBbox = (bbox_string, os = "ios") => {
  // Convert the bbox string to an array of numbers
  const bbox_array = bbox_string.slice(1, -1).split(",").map(Number);

  // Rearranging to ensure proper order: [west, south, east, north]
  let [west, south, east, north] = bbox_array;

  const normalized_bounds = [
    [east, north],
    [west, south],
  ];

  // Return the formatted coordinates array
  return normalized_bounds;
};
